export const seccionesOrganos = [
  {
    titulo: 'JUNTA DIRECTIVA',
    items: [
      { cargo: 'Presidente',        nombre: 'Celvin Leodan Valladares',          cooperativa: 'Cooperativa Taulabe, Ltda.' },
      { cargo: 'Vice-Presidente',   nombre: 'Nelson Edmundo Mejía Paz',          cooperativa: 'Cooperativa Standard Fruit Company, Ltda.' },
      { cargo: 'Secretario',        nombre: 'Oscar Javier Raudales Zepeda',      cooperativa: 'Cooperativa Talanga, Ltda.' },
      { cargo: 'Vocalía I',         nombre: 'María Argentina Cabrera López',     cooperativa: 'Cooperativa Mixta La Prosperidad, Ltda.' },
      { cargo: 'Vocalía II',        nombre: 'Dilma Paola Villatora Ramírez',     cooperativa: 'Cooperativa Pespireños, Ltda.' },
      { cargo: 'Vocalía III',       nombre: 'Elvin Nael Escobar Morazán',        cooperativa: 'Cooperativa Cuna Maya, Ltda.' },
      { cargo: 'Vocalía IV',        nombre: 'Rosa Emma Reyes Chávez',            cooperativa: 'Cooperativa COMIXMAL' },
      { cargo: 'Suplencia',         nombre: 'Reynieri Aguilar Mejía',            cooperativa: 'Cooperativa Intibucana, Ltda.' }
    ]
  },
  {
    titulo: 'JUNTA DE VIGILANCIA',
    items: [
      { cargo: 'Presidente',        nombre: 'Leonel Antonio López Benítez',      cooperativa: 'Cooperativa COMEGA, Ltda.' },
      { cargo: 'Secretario',        nombre: 'Máximo Portillo Espinal',           cooperativa: 'Cooperativa Fe y Esperanza, Ltda.' },
      { cargo: 'Vocalía I',         nombre: 'Melvin Alexander Escobar Euceda',   cooperativa: 'Cooperativa COMIMEL, Ltda.' },
      { cargo: 'Vocalía II',        nombre: 'Carlos Armando Rivera Rivera',      cooperativa: 'Cooperativa María Claret, Ltda.' },
      { cargo: 'Vocalía III',       nombre: 'Whalter Aníbal Alvarado Caballero', cooperativa: 'Cooperativa Nueva Vida, Ltda.' },
      { cargo: 'Vocalía IV',        nombre: 'Adilia María Murillo Núñez',        cooperativa: 'Cooperativa Pacura Agún, Ltda.' },
      { cargo: 'Vocalía V',         nombre: 'Salvadora Ventura Santos',          cooperativa: 'Cooperativa Esfuerzo Langueño, Ltda.' },
      { cargo: 'Suplencia',         nombre: 'Oscar Omar Reyes Bonilla',          cooperativa: 'Cooperativa Mixta Usula, Ltda.' }
    ]
  },
  {
    titulo: 'GERENCIA GENERAL',
    items: [
      { cargo: '', nombre: 'Edgar Omar Hernández Zúñiga', cooperativa: '' }
    ]
  }
];




